import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { AppState } from '../../redux/modules';

export default connect((state: AppState) => ({
  locale: state.locale.lang,
  key: state.locale.lang,
  messages: state.locale.messages,
}))(IntlProvider);
